import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";

export const STT_ERROR_CODE_MICROPHONE_ACCESS_DENIED = "microphone_access_denied";
export const STT_ERROR_CODE_MICROPHONE_UNAVAILABLE = "microphone_unavailable";
export const STT_ERROR_CODE_NETWORK = "network_error";
export const STT_ERROR_CODE_RECORDING = "recording_error";
export const STT_ERROR_CODE_INVALID_AUDIO = "invalid_audio";
export const STT_ERROR_CODE_TRANSCRIPTION = "transcription_error";

// Centralize error-code-to-copy mapping so recorder states use consistent user messaging.
const MICROPHONE_HELP_ERROR_CODES = new Set([
  STT_ERROR_CODE_MICROPHONE_ACCESS_DENIED,
  STT_ERROR_CODE_MICROPHONE_UNAVAILABLE
]);

const ERROR_MESSAGE_KEY_BY_CODE = {
  [STT_ERROR_CODE_MICROPHONE_ACCESS_DENIED]: "microphoneAccessDenied",
  [STT_ERROR_CODE_MICROPHONE_UNAVAILABLE]: "microphoneUnavailable",
  [STT_ERROR_CODE_NETWORK]: "networkError",
  [STT_ERROR_CODE_RECORDING]: "recordingError",
  [STT_ERROR_CODE_INVALID_AUDIO]: "recordingError",
  [STT_ERROR_CODE_TRANSCRIPTION]: "transcriptionError"
};

const SpeechToTextRecorderError = ({ errorCode, helpUrl, helpLabel }) => {
  const t = useFormatMessage();
  const errorMessageKey = ERROR_MESSAGE_KEY_BY_CODE[errorCode];
  const message = errorMessageKey ? t(intlMessages[errorMessageKey]) : null;
  if (!message) return null;

  const showHelpLink = MICROPHONE_HELP_ERROR_CODES.has(errorCode) && !!helpUrl;

  return (
    <p className="form-text text-danger speech-to-text-recorder__error">
      {message}
      {showHelpLink && (
        <>
          &nbsp;
          <a href={helpUrl} target="_blank" rel="noopener noreferrer">
            {helpLabel}
          </a>
        </>
      )}
    </p>
  );
};

export default SpeechToTextRecorderError;

const intlMessages = defineMessages({
  microphoneAccessDenied: {
    id: "speechToTextRecorder.microphoneAccessDenied",
    defaultMessage:
      "L'accès au micro est bloqué. Autorisez le micro dans votre navigateur."
  },
  microphoneUnavailable: {
    id: "speechToTextRecorder.microphoneUnavailable",
    defaultMessage:
      "L'accès au micro n'est pas disponible. Vérifiez les permissions du navigateur."
  },
  recordingError: {
    id: "speechToTextRecorder.recordingError",
    defaultMessage: "L'enregistrement n'a pas pu être traité. Merci de réessayer."
  },
  networkError: {
    id: "speechToTextRecorder.networkError",
    defaultMessage:
      "Le réseau semble indisponible. La transcription n'a pas pu être envoyée."
  },
  transcriptionError: {
    id: "speechToTextRecorder.transcriptionError",
    defaultMessage: "La transcription a échoué. Merci de réenregistrer votre message."
  }
});
